import { isLocalParticipantModerator, isParticipantModerator } from "../base/participants/functions";
const getState = (state) => state['features/poll-moderation'];
export const isEnableBanAllPoll = (state) => getState(state)?.enabled;
export const isLocalParticipantCanPoll = (state) => {
    if (isLocalParticipantModerator(state)) {
        return true;
    }
    const { canPoll } = getState(state);
    if (canPoll !== undefined) {
        return canPoll;
    }
    return !isEnableBanAllPoll(state);
};
export const isParticipantApprovedPoll = (participantId, state) => getState(state)?.whitelist[participantId];
export const isParticipantRejectedPoll = (participantId, state) => getState(state)?.blacklist[participantId];
export function isBannedPoll(participant, state) {
    if (participant.local) {
        return !isLocalParticipantCanPoll(state);
    }
    // moderators cannot be mute chat
    if (isParticipantModerator(participant)) {
        return false;
    }
    if (isEnableBanAllPoll(state)) {
        return !isParticipantApprovedPoll(participant.id, state);
    }
    return Boolean(isParticipantRejectedPoll(participant.id, state));
}
